import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
function ResumeLoader(props) {
	return (
		<div className="p-3">
			<div className="row mt-3 ">
				<div className="col-md-4 ">
					<div className="mx-5">
						<Skeleton
							width="80px"
							height="80px"
							borderRadius="10px"
							containerClassName="avatar-skeleton"
						/>
					</div>

				</div>
				<div className="col-md-8 mt-1">
					<Skeleton
						containerClassName="avatar-skeleton"
					/>
					<Skeleton
						containerClassName="avatar-skeleton"
					/>
					<Skeleton
						containerClassName="avatar-skeleton"
					/>
				</div>
			</div>

			{[...Array(props.count)].map((x, i) =>
				<div className="row mt-3" >
					<div className="col-md-4">
						<Skeleton
							containerClassName="avatar-skeleton"
						/>
						<Skeleton
							containerClassName="avatar-skeleton"
						/>
						<Skeleton
							containerClassName="avatar-skeleton"
						/>
					</div>
					<div className="col-md-8">
						<Skeleton
							containerClassName="avatar-skeleton"
						/>
						<Skeleton
							containerClassName="avatar-skeleton"
						/>
						<Skeleton
							containerClassName="avatar-skeleton"
						/>
					</div>
				</div>
			)}




		</div>
	)
}

export default ResumeLoader
